'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.directive('focusMe', function ($timeout, $parse) {
    return {
      link: function link($scope, $element, $attr) {
        var model = $parse($attr.focusMe);
        $scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              $element[0].focus();
            });
          } else {
            $timeout(function () {
              $element[0].blur();
            });
          }
        });
        $element.on('focus', function () {
          $scope.$apply(model.assign($scope, true));
        });
        $element.on('blur', function () {
          $scope.$apply(model.assign($scope, false));
        });
      }
    };
  });
  return app;
};

require('angular');

/**
 * 为input提供一个外部调用的变量 用来控制其焦点
 */

;


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/directives/focusMe.js
// module id = 143
// module chunks = 0